import {
  MEDIA_VIDEO_GET_BY_FILTER,
  MEDIA_VIDEO_GET_BY_FILTER_SUCCESS,
  MEDIA_VIDEO_GET_BY_FILTER_ERROR,
  MEDIA_VIDEO_GET_BY_ID,
  MEDIA_VIDEO_GET_BY_ID_SUCCESS,
  MEDIA_VIDEO_GET_BY_ID_ERROR,
  MEDIA_VIDEO_UPLOAD_MANY,
  MEDIA_VIDEO_UPLOAD_MANY_SUCCESS,
  MEDIA_VIDEO_UPLOAD_MANY_ERROR,
  MEDIA_VIDEO_UPLOAD,
  MEDIA_VIDEO_UPLOAD_SUCCESS,
  MEDIA_VIDEO_UPLOAD_ERROR,
  MEDIA_VIDEO_PATCH,
  MEDIA_VIDEO_PATCH_SUCCESS,
  MEDIA_VIDEO_PATCH_ERROR,
  MEDIA_VIDEO_DELETE,
  MEDIA_VIDEO_DELETE_SUCCESS,
  MEDIA_VIDEO_DELETE_ERROR,
  MEDIA_VIDEO_DELETE_LIST,
  MEDIA_VIDEO_DELETE_LIST_SUCCESS,
  MEDIA_VIDEO_DELETE_LIST_ERROR,
  // New streaming upload action types
  MEDIA_VIDEO_STREAMING_UPLOAD_START,
  MEDIA_VIDEO_STREAMING_UPLOAD_PROGRESS,
  MEDIA_VIDEO_STREAMING_UPLOAD_SUCCESS,
  MEDIA_VIDEO_STREAMING_UPLOAD_ERROR,
  MEDIA_VIDEO_STREAMING_UPLOAD_CANCEL,
} from './type'

export default function (
  state = {
    entity: null,
    streamingUploads: {}, // Track multiple uploads by uploadId
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case MEDIA_VIDEO_GET_BY_FILTER:
      return {
        ...state,
        loading: true,
      }
    case MEDIA_VIDEO_GET_BY_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: payload.entity,
      }
    case MEDIA_VIDEO_GET_BY_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      }
    case MEDIA_VIDEO_GET_BY_ID:
      return {
        ...state,
        loading: true,
      }
    case MEDIA_VIDEO_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: payload.entity,
      }
    case MEDIA_VIDEO_GET_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      }
    case MEDIA_VIDEO_UPLOAD_MANY:
      return {
        ...state,
        loading: true,
      }
    case MEDIA_VIDEO_UPLOAD_MANY_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: payload.entity,
      }
    case MEDIA_VIDEO_UPLOAD_MANY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      }
    case MEDIA_VIDEO_UPLOAD:
      return {
        ...state,
        loading: true,
      }
    case MEDIA_VIDEO_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: payload.entity,
      }
    case MEDIA_VIDEO_UPLOAD_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      }
    case MEDIA_VIDEO_PATCH:
      return {
        ...state,
        loading: true,
      }
    case MEDIA_VIDEO_PATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: payload.entity,
      }
    case MEDIA_VIDEO_PATCH_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      }
    case MEDIA_VIDEO_DELETE:
      return {
        ...state,
        loading: true,
      }
    case MEDIA_VIDEO_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: payload.entity,
      }
    case MEDIA_VIDEO_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      }
    case MEDIA_VIDEO_DELETE_LIST:
      return {
        ...state,
        loading: true,
      }
    case MEDIA_VIDEO_DELETE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        entity: payload.entity,
      }
    case MEDIA_VIDEO_DELETE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload.error,
      }

    // New streaming upload cases
    case MEDIA_VIDEO_STREAMING_UPLOAD_START:
      return {
        ...state,
        streamingUploads: {
          ...state.streamingUploads,
          [payload.uploadId]: {
            id: payload.uploadId,
            fileName: payload.file.name,
            fileSize: payload.file.size,
            parentFolderId: payload.parentFolderId,
            status: 'uploading',
            progress: 0,
            bytesProcessed: 0,
            startTime: Date.now(),
            error: null,
          },
        },
      }

    case MEDIA_VIDEO_STREAMING_UPLOAD_PROGRESS:
      // If upload was cancelled, ignore progress updates
      if (!state.streamingUploads[payload.uploadId]) {
        return state
      }

      return {
        ...state,
        streamingUploads: {
          ...state.streamingUploads,
          [payload.uploadId]: {
            ...state.streamingUploads[payload.uploadId],
            status: payload.progress.status || state.streamingUploads[payload.uploadId].status,
            progress: payload.progress.percentComplete || 0,
            bytesProcessed: payload.progress.bytesProcessed || 0,
            message: payload.progress.message || '',
            totalBytes: payload.progress.totalBytes || 0,
          },
        },
      }

    case MEDIA_VIDEO_STREAMING_UPLOAD_SUCCESS:
      // If upload was cancelled, ignore success updates
      if (!state.streamingUploads[payload.uploadId]) {
        return state
      }

      return {
        ...state,
        streamingUploads: {
          ...state.streamingUploads,
          [payload.uploadId]: {
            ...state.streamingUploads[payload.uploadId],
            status: 'completed',
            progress: 100,
            endTime: Date.now(),
            response: payload.response,
          },
        },
      }

    case MEDIA_VIDEO_STREAMING_UPLOAD_ERROR:
      // If upload was cancelled, ignore error updates
      if (!state.streamingUploads[payload.uploadId]) {
        return state
      }

      return {
        ...state,
        streamingUploads: {
          ...state.streamingUploads,
          [payload.uploadId]: {
            ...state.streamingUploads[payload.uploadId],
            status: 'error',
            error: payload.error,
            endTime: Date.now(),
          },
        },
      }

    case MEDIA_VIDEO_STREAMING_UPLOAD_CANCEL:
      const {
        [payload.uploadId]: removed,
        ...remainingUploads
      } = state.streamingUploads
      return {
        ...state,
        streamingUploads: remainingUploads,
      }

    default:
      return state
  }
}
